/** =======================================================
 * 기존에는 웹소켓 통신을 하고나서야 clientId가 생성됨.
 * Comfy.ParameterLoaded는 파라미터로 부른적이 있는지를 세션별로 관리하는데,
 * getStorageValue 함수에서 clientId가 존재하면 세션으로 관리해주기때문에
 * 이를 해결하기 위해 웹소켓 통신 이전에 clientId를 생성하여 사용
 * ========================================================= */
export const createClientSessionId = () => {
  const cliendId = sessionStorage.getItem('clientId')

  if (cliendId) {
    return cliendId
  }

  const clientSessionId = generateClientSessionId()
  window.name = clientSessionId

  sessionStorage.setItem('clientId', clientSessionId)

  return clientSessionId
}

const generateClientSessionId = () => {
  const randomId = Math.random().toString(36).substring(2, 20)
  const timestamp = Date.now()
  return `${randomId}-${timestamp}`
}
